import React from 'react';


export default class Component extends React.Component {
  
  render (){

    return (
      <div className="flex-center">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfQeKVl8otlSmzH3HDeMSitySfquHt3kLLy2tvmzNSI3UcsDA/viewform?embedded=true" width="640" height="1062" frameBorder="0" marginHeight="0" marginWidth="0">Loading…</iframe>
      </div>
    )
  }
}


